export default "__VITE_ASSET__Dn2AuL2c__"